export const scrollToSection = (id) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(id, { offset: -64, duration: 1.6 });
  } else {
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  }
};
